// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Keeps the chosen tool on one line: the label shrinks and ends with an ellipsis instead of wrapping. */
.single-line-select[data-v-3ea0d5a5] .vs__selected-options {
  flex-wrap: nowrap;
  min-width: 0;
}
.single-line-select[data-v-3ea0d5a5] .vs__selected {
  display: block;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
